import { Component, Input, SimpleChanges } from '@angular/core';
import { InvoiceDetail } from '@app/core/api-azure-functions/dataverse-functions/model/invoice';
import { AbstractMatTableComponent } from '@app/shared/base/abstract-mat-table/abstract-mat-table.component';
import { Router } from '@angular/router';
import { SiteDetailsModel } from '@app/core/models/site.model';

@Component({
  selector: 'app-customer-invoices-table',
  templateUrl: './customer-invoices-table.component.html',
  styleUrls: ['./customer-invoices-table.component.scss'],
})
export class CustomerInvoicesTableComponent extends AbstractMatTableComponent {
  @Input() currentSite: SiteDetailsModel;
  displayedColumns: string[] = [
    'paymentStatus',
    'invoiceNumber',
    'invoiceDate',
    'total',
    'action',
  ];
  originalData: any[] = []; // Store original data

  constructor(private router: Router) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.originalData = this.dataSource.data;
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    if (this.sort) {
      this.sort.active = 'invoiceDate';
      this.sort.direction = 'desc';
      this.dataSource.sort = this.sort;
    }
  }

  onInvoiceSelect(customerId: string, invoiceId: string) {
    this.router.navigate([
      'invoices/details/',
      customerId,
      invoiceId,
      this.currentSite.accountId,
    ]);
  }

  onInvoicePay(element: InvoiceDetail) {
    if (
      element.rtsPaymentLink &&
      element.rtsPaymentLink.length &&
      element.total > 0 &&
      element.paymentStatus !== 'Paid'
    ) {
      window.open(element.rtsPaymentLink, '_blank', 'noopener,noreferrer');
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
  }
}
